import { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Paper,
} from '@mui/material';
import {
  Chat as ChatIcon,
  Notes as NotesIcon,
} from '@mui/icons-material';
import StructuredNotes from './StructuredNotes';
import LiveChat from './LiveChat';

function VoiceToNotes() {
  const [mode, setMode] = useState('notes');

  const handleModeChange = (event, newMode) => {
    if (newMode !== null) {
      setMode(newMode);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Voice to Notes
        </Typography>
        <Paper sx={{ p: 1, display: 'inline-block' }}>
          <ToggleButtonGroup
            value={mode}
            exclusive
            onChange={handleModeChange}
            aria-label="voice mode"
          >
            <ToggleButton value="notes" aria-label="structured notes">
              <NotesIcon sx={{ mr: 1 }} />
              Structured Notes
            </ToggleButton>
            <ToggleButton value="chat" aria-label="live chat">
              <ChatIcon sx={{ mr: 1 }} />
              Live Chat
            </ToggleButton>
          </ToggleButtonGroup>
        </Paper>
      </Box>

      <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', borderRadius: 1, overflow: 'hidden' }}>
        {mode === 'notes' ? <StructuredNotes /> : <LiveChat />}
      </Box>
    </Container>
  );
}

export default VoiceToNotes;
